export const GENRES = {
    ARTWORK: 'artwork',
    MUSIC: 'music',
    PHOTOGRAPHY: 'photography',
    VIDEO: 'video',
    PODCAST: 'podcast',
    BOOK: 'book',
    CLOTHING: 'clothing',
    CRAFT: 'handmade_craft',
    // COURSE: 'course',
    // SOFTWARE: 'software'
};

export const GENRE_LABELS = {
    [GENRES.MUSIC]: 'Music',
    [GENRES.PODCAST]: 'Podcast',
    [GENRES.VIDEO]: 'Film',
    [GENRES.ARTWORK]: 'Artwork',
    [GENRES.PHOTOGRAPHY]: 'Photography',
    [GENRES.CLOTHING]: 'Clothing',
    [GENRES.BOOK]: 'Book',
    [GENRES.CRAFT]: 'Craft',
    // [GENRES.SOFTWARE]: 'Software'
};

export const GENRE_ICONS = {
    [GENRES.MUSIC]: 'library-music',
    [GENRES.PODCAST]: 'library-podcast',
    [GENRES.VIDEO]: 'library-video',
    [GENRES.ARTWORK]: 'library-artwork',
    [GENRES.PHOTOGRAPHY]: 'library-photography',
    [GENRES.CLOTHING]: 'library-clothing',
    [GENRES.BOOK]: 'library-book',
    [GENRES.CRAFT]: 'library-handmade',
    // [GENRES.SOFTWARE]: 'code'
}; 